define('collections/products_usa',['require','collections/base','models/product'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/product");

    return BaseCollection.extend({
        model: Model,
        url: 'usa-products.json'
    });
});

